import Vue from 'vue'
import Router from 'vue-router'

import certificate from './views/Certificate/CertificateSearch'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
        path:'/certificate',
        name:'certificate',
        component: certificate
    },   
  ]
})

router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router